import { Dispatch } from "redux";
import { toast } from "react-toastify";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import {
    setError,
    setEmailError,
    setIsPatchEditEmployeeSuccess,
    setShowEmailEdit,
    setResetEmailState,
} from "../EditEmployeeModalSlice";
import { getResetEmailState } from "./getResetEmailState";

interface HandleEmailChangeProps {
    newEmail: string;
    selectedEmployee?: EmployeeInterface;
    dispatch: Dispatch;
    changeEmail: (params: { id: number; newEmail: string }) => {
        unwrap: () => Promise<unknown>;
    };
}

export const handleEmailChange = async (
    props: HandleEmailChangeProps,
): Promise<boolean> => {
    const { newEmail, selectedEmployee, dispatch, changeEmail } = props;

    if (!newEmail || !selectedEmployee) {
        return true; // Continue with regular employee update
    }

    try {
        await changeEmail({
            id: selectedEmployee.id,
            newEmail: newEmail,
        }).unwrap();
        toast.info("Verzoek om e-mailadres te wijzigen is verstuurd");
        dispatch(setIsPatchEditEmployeeSuccess(true));
        dispatch(setError(null)); // Clear any existing general error messages
        dispatch(setEmailError(null)); // Clear any existing email-specific error messages

        // Reset email fields
        dispatch(setResetEmailState(getResetEmailState()));

        // Hide the email edit component
        dispatch(setShowEmailEdit(false));

        return true; // Continue with regular employee update
    } catch (err) {
        const errorData = err as ErrorInterface;
        // Add null check to prevent "Cannot read properties of undefined (reading 'message')" error
        const errorMessage =
            errorData?.data?.message ||
            "Er is een fout opgetreden bij het wijzigen van het e-mailadres";
        dispatch(setError(errorMessage));
        return false; // Don't continue with regular employee update
    }
};
